export default "__VITE_ASSET__ByQA7WB___"